<template>
  <div ref="room" class="room">
    <vb-card
      variant="horizontal"
      :card="{
        image: room_image,
        title: room_name,
        text: room.description,
        text_clamped: true,
      }"
      @click_image="$bvModal.show(modal_id)"
    >
      <span
        v-if="room.description"
        v-b-modal="modal_id"
        class="room__readmore"
      >leggi tutto</span>

      <vb-modal
        :vb_options="{
          id: modal_id,
          body_class: 'room__modal',
          centered: true,
          hide_footer: true,
          size: 'lg',
        }"
      >
        <carousel :images="carousel_images" />
        <h5 class="room__modal-title" v-html="room_name"></h5>
        <p class="room__modal-description" v-html="room.description"></p>
      </vb-modal>

      <div v-if="rates.length" class="room__footer">
        <div class="room__rates">
          <vb-select
            v-model="selected_rate_idx"
            :vb_options="{
              options: rate_options,
              value: selected_rate_idx,
            }"
          />
          <span v-if="current_rate && current_rate.pricing" class="room__price">
            {{ markup(current_rate.pricing.total).display_price }}&euro;
          </span>
        </div>

        <vb-button
          :vb_options="{
            text: is_selected ? 'Selezionata' : 'Scegli',
            variant: is_selected ? 'outline-info' : 'dark',
            size: 'md',
            disabled: is_selected,
          }"
          @click="select_room"
        />
      </div>
    </vb-card>
  </div>
</template>

<script>
  import { room_carousel_images } from '@alpitour/utilities/images';
  import Carousel from '@/components/blocks/images/carousel.vue';
  export default {
    name: 'room',
    components: {
      carousel: Carousel,
    },

    inject: ['on_room_selected', 'room_selection'],

    inheritAttrs: false,

    props: {
      room: {
        type: Object,
        default: () => ({}),
      },
      room_index: {
        type: Number,
        default: 0,
      },
    },
    data() {
      return {
        selected_rate_idx: 0,
        confirmed_rate: null,
      };
    },

    computed: {
      modal_id() {
        return `room-modal-${this._uid}`;
      },

      room_name() {
        if (!this.room.name) return '';
        return (
          this.room.name.charAt(0).toUpperCase() +
          this.room.name.slice(1).toLowerCase()
        );
      },

      carousel_images() {
        return room_carousel_images(this.room);
      },

      room_image() {
        const { images } = this.room;
        if (images && images.length && images[0].url) return images[0].url;
        return '';
      },

      rates() {
        return this.room.rates || [];
      },

      rate_options() {
        return this.rates.map((rate, index) => ({
          value: index,
          text: rate.description
            ? rate.description.charAt(0).toUpperCase() +
              rate.description.slice(1).toLowerCase()
            : '',
        }));
      },

      current_rate() {
        return this.rates[this.selected_rate_idx] || null;
      },

      is_selected() {
        return (
          this.room_selection.index === this.room_index &&
          this.confirmed_rate !== null &&
          this.confirmed_rate === this.selected_rate_idx
        );
      },
    },

    methods: {
      select_room() {
        this.confirmed_rate = this.selected_rate_idx;
        this.on_room_selected({
          room_index: this.room_index,
          rate: this.current_rate,
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .room {
    &__readmore {
      position: absolute;
      margin-top: -0.925rem;
      right: 1.9rem;
      background: $white;
      padding-left: $grid-gutter-width/3;
      color: $info;
      text-decoration: underline;
      cursor: pointer;
      font-size: $font-size-sm;
    }

    &__modal {
      &-image {
        width: 100%;
        border-radius: $border-radius-lg;
        margin-bottom: $grid-gutter-width / 3;
      }

      &-title {
        margin-bottom: $grid-gutter-width / 6;
      }

      &-description {
        font-size: $font-size-sm;
        margin-bottom: 0;
      }
    }

    &__footer {
      margin-top: $grid-gutter-width / 3;
      padding-top: $grid-gutter-width / 3;
      border-top: 1px solid $gray-200;

      @include media-breakpoint-up(lg) {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }

    &__rates {
      display: flex;
      align-items: center;
      flex-basis: 80%;
      margin-right: $grid-gutter-20;

      @include media-breakpoint-up(xl) {
        flex-basis: 60%;
      }
    }

    &__price {
      font-weight: $vb-font-weight-semibold;
      font-size: $font-size-lg;
      white-space: nowrap;
      margin-left: $grid-gutter-width / 2;
    }

    .vb-select {
      font-size: $font-size-sm;
    }

    .vb-btn {
      display: block;
      width: 100%;
      margin-top: $grid-gutter-width/3;
      border: 1px solid transparent !important;

      @include media-breakpoint-up(xl) {
        margin-top: 0;
        flex-basis: 30%;
      }
    }
  }
</style>
